import { Stack, Typography, useTheme } from "@mui/material";
import { IArticle } from "../../../types/global-features";

const ArticlePreface = ({
    scrollOffset = 0,
    viewedArticle,
}: {
    scrollOffset?: number;
    viewedArticle: Partial<IArticle> | undefined;
}) => {
    const theme = useTheme();
    const goToSection = (index: number) => {
        const headers = document.querySelectorAll(".article-body h3");
        const header = headers.item(index) as HTMLElement;

        const stickyHeight = scrollOffset + 8;
        const offset = header.offsetTop - stickyHeight;
        window.scrollTo({ top: offset, behavior: "smooth" });
    };

    const bodyEl = document.createElement("div");
    bodyEl.innerHTML = viewedArticle?.body || "";

    const tocList: string[] = [];
    const sectionHeaders = bodyEl.querySelectorAll("h3");
    sectionHeaders.forEach((node) => {
        if (node.innerText) tocList.push(node.innerText);
    });

    return (
        <Stack spacing={2} className="newsletter-preface">
            {viewedArticle?.summary && <Typography>{viewedArticle?.summary}</Typography>}
            <ul className="table-of-contents" style={{ width: "max-content", margin: 0 }}>
                {tocList.map((text, i) => (
                    <li
                        style={{
                            marginBottom: "0.25rem",
                        }}
                        key={text}
                    >
                        <span
                            onClick={() => goToSection(i)}
                            style={{
                                color: theme.palette.primaryPurple.main,
                                textDecoration: "underline",
                                textUnderlineOffset: "2px",
                                cursor: "pointer",
                            }}
                        >
                            {text}
                        </span>
                    </li>
                ))}
            </ul>
        </Stack>
    );
};

export default ArticlePreface;
